// We only need to import the modules necessary for initial render
import { endsWith, get, isEmpty } from 'lodash';

import CoreLayout from '../layouts/CoreLayout/CoreLayout';
import userService from '../services/user-service';
import LoyaltyRedeem from './LoyaltyRedeem';
import OfferActivation from './OfferActivation';
import GiftVoucherActivation from './GiftVoucherActivation';
import CustomerDetails from './CustomerDetails';
import CustomerOffers from './CustomerOffers';

// We only need to import the modules necessary for initial render
// import PWAConfig from "./PWAConfig";
/*  Note: Instead of using JSX, we recommend using react-router
    PlainRoute objects to build route definitions.   */
export const createRoutes = (store, keycloak) => ({
  path: "/",
  component: CoreLayout,
  indexRoute: {
    onEnter: (nextState, replace, callback) => {
      let keycloakToken = keycloak !== undefined ? keycloak.token : "";
      return userService
        .getCurrentUser(keycloakToken)
        .then((user) => {
          let isCustomerAssociate = userService.isCustomerAssociate(user);
          let userRole = userService.getUserRole(user);
          let redirectRoute = get(
            get(userRole, "generalConfig", {}),
            "dashboardPrimaryPage",
            ""
          );
          if (!isEmpty(redirectRoute)) {
            let redirection = userService.routeStringTemplate(redirectRoute);
            replace(redirection);
          } else {
            if (isCustomerAssociate) {
              replace("/customer-details");
            } else {
              let isDemoUser = endsWith(get(user, "tenant.esKey"), "_demo");
              replace(
                isDemoUser
                  ? "/purchases-clustering-analytics"
                  : "/overall-summary"
              );
            }
          }
          callback();
        })
        .catch(() => callback(replace("/login")));
    },
  },
  childRoutes: [
    // LoginRoute(store),
    // CampaignRoute(store),
    // HomeRoute(store),
    // ReportRoute(store),
    // PlaceHolderRoute(store),
    // SegmentRoute(store),
    // AnalysisRoute(store),
    // CampaignDistributionRoute(store),
    // CampaignEfficiencyRoute(store),
    // MarketSegmentRoute(store),
    // FacebookCampaignInsightsRoute(store),
    // ProductDemographyRoute(store),
    // CustomerInterestsRoute(store),
    // CustomerInsightsRoute(store),
    // WalkInInterestsRoute(store),
    // ChatbotInterestsRoute(store),
    // LeadManagementRoute(store),
    // LeadCreationRoute(store),
    // LeadConversionDaysAnalyticsRoute(store),
    // NpsUserSegmentRoute(store),
    // LeadDistributionAnalyticsRoute(store),
    // LeadDropAnalyticsRoute(store),
    // OrderManagementRoute(store),
    // StateManagerRoute(store),
    // WalkInInterestsPrintRoute(store),
    // ProductSalesAnalyticsRoute(store),
    // CustomerPurchaseAnalytics(store),
    // AllProductSalesAnalyticsRoute(store),
    // FormResponseAnalyticsRoute(store),
    // OrderCapturePrint(store),
    // OrderCapture(store),
    // OrderDetailsRoute(store),
    // SalesAnalytics(store),
    // DetailedAnalytics(store),
    // AutoLoginRedirect(store),
    // OpportunityAnalyticsRoute(store),
    // CategoryInsightsRoute(store),
    // SalesForecastRoute(store),
    // ProductSalesForecastRoute(store),
    // CaptivePortalRoute(store),
    // OffersAnalytics(store),

    // OfferMaster(store),
    // OpportunitiesRoute(store),
    // ProductWiseSalesAnalytics(store),
    // SinglePurchaseClusteringRoute(store),
    // MultiplePurchaseClusteringRoute(store),
    // BillPurchaseClusteringRoute(store),
    // CategoryAnalytics(store),
    CustomerDetails(store),
    // OverallSummary(store),
    // Offer(store),
    // OfferView(store),
    // Flipbook(store),
    // CloneOffer(store),
    // SocialMediaReward(store),
    // SocialMediaRewardList(store),
    CustomerOffers(store),
    // CampaignCreation(store),
    // LoyaltyTier(store),
    // LoyaltyAdhocPoints(store),
    // LoyaltySummary(store),
    // LoyaltyTierStat(store),
    // LeadManagementCategoryWiseReport(store),
    // CrossChannelAnalysis(store),
    // SendCampaignMessagePage(store),
    // CromaRseReferral(store),
    // MembershipPage(store),
    // EcomOrderManagement(store),
    // ForgotPassword(store),
    // B2BOfferModule(store),
    // B2BOffersReport(store),
    // KamExpenses(store),
    // Labeling(store),
    // JourneyCreate(store),
    // JourneyListing(store),
    // ManageCohorts(store),
    // CreateCohorts(store),
    // StaticFileExchange(store),
    // CampaignList(store),
    // CampaignCreate(store),
    // CommerceConnect(store),
    // LatencyCampaignCreate(store),
    // FormCreate(store),
    // FormList(store),
    // RoleConfig(store),
    // RoleConfig2(store),
    // EmailConfig(store),
    // TenantConfig(store),
    // SmsConfig(store),
    // MufflerConfig(store),
    // StoresConfig(store),
    // DataUpload(store),
    // UploadLogs(store),
    // ParallelUpload(store),
    // UserDataDownload(store),
    // AccountManagement(store, keycloak),
    // FieldSalesAssist(store),
    // UserListing(store),
    // Logout(store, keycloak),
    // LMSConfig(store),
    LoyaltyRedeem(store),
    OfferActivation(store),
    GiftVoucherActivation(store),
    // LoyaltyConfig(store),
    // LoyaltyException(store),
    // // PWAConfig(store),
    // GeneralSetting(store),
    // ClientOffers(store),
    // Channels(store),
    // LoyaltyRedeemConfiguration(store),
    // ReferralConfiguration(store),
    // LoyaltyPoints(store),
    // Offerio(store),
    // StoreManagement(store),
    // PWAConfig(store),
    // PwaLoyaltySignUp(store),
    // OfferSearch(store),
    // ProductManagement(store),
    // LiveReports(store),
    // OTPConfiguration(store),
    // InvoiceCreator(store),
    // CreateCustomerGroup(store),
    // EditCustomerGroup(store),
    // TransactionWiseReport(store),
    // CampaignDetails(store),
    // CampaignReports(store),
    // TransactionWiseReportDownload(store),
    // FraudReport(store),
    // MemberReport(store),
    // MemberBillReport(store),
    // TenantReport(store),
    // MigrateCustomers(store),
    // TenantFieldMapping(store),
    // FrequencyGraph(store),
    // StoreHealthGenerate(store),
    // StoreHealthView(store),
    // LiabilitySummaryReport(store),
  ],
  keycloak: keycloak,
});

/*  Note: childRoutes can be chunked or otherwise loaded programmatically
    using getChildRoutes with the following signature:

    getChildRoutes (location, cb) {
      require.ensure([], (require) => {
        cb(null, [
          // Remove imports!
          require('./Counter').default(store)
        ])
      })
    }

    However, this is not necessary for code-splitting! It simply provides
    an API for async route definitions. Your code splitting should occur
    inside the route `getComponent` function, since it is only invoked
    when the route exists and matches.
*/

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.js